import { inject, Injectable, InjectionToken } from '@angular/core';
import { FormArray } from '@angular/forms';
import { QuestionItem } from '@examdojo/models/question';
import { QuestionEditingOptions } from '@examdojo/models/question-editor';
import { QuestionItemsFormService, TopLevelFormGroup } from '@examdojo/question';
import { BehaviorSubject, Observable } from 'rxjs';

export const QUESTION_ITEMS_DATA = new InjectionToken<Observable<QuestionItem[] | null>>('QUESTION_ITEMS_DATA');

@Injectable()
export class SimpleQuestionItemsViewerFormService extends QuestionItemsFormService {
  readonly form = new FormArray<TopLevelFormGroup>([]);

  readonly editingOptions$ = new BehaviorSubject<QuestionEditingOptions | null>({
    allowImageEditing: [],
    allowQuestionEditing: false,
    allowMarkschemeEditing: false,
    allowMcqEditing: false,
    hideBadges: true,
    hideQuestionDetailsHeader: true,
  });

  override readonly questionItems$ = inject(QUESTION_ITEMS_DATA);
}
